const defaultSensorDisplayDatapoints = [
  'temperature',
  'probe_temp',
  'humidity',
  'battery',
  'power',
  'rssi',
];

export default defaultSensorDisplayDatapoints;
